export default __webpack_public_path__ + "static/media/marker.8e654267.svg";